import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { clearFilters } from '../../actions/FiltersActions';
import { clearTickets, searchTickets } from '../../actions/TicketActions';
import { jsx as _jsx } from "react/jsx-runtime";
function ClearFiltersButton() {
  const dispatch = useDispatch();
  const searchTerms = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.searchTerms);
  function handleLinkClicked() {
    if (!searchTerms.trim()) {
      dispatch(clearFilters());
      dispatch(clearTickets());
    } else {
      dispatch(clearFilters());
      dispatch(searchTickets(searchTerms, undefined, 'filters-cleared'));
    }
  }
  return /*#__PURE__*/_jsx(UILink, {
    "data-test-id": "clear-filters-button-internal",
    onClick: handleLinkClicked,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "clear-filters-button-label",
      message: "app.common.clearFilters"
    })
  });
}
export default /*#__PURE__*/memo(ClearFiltersButton);